export enum Constants {
  ADD_PLAYER = '@lineupBuilder/add_player',
  REMOVE_PLAYER = '@lineupBuilder/remove_player',
  SELECT_LINEUP = '@lineupBuilder/select_lineup',
  CREATE_LINEUP = '@lineupBuilder/create_lineup',
  SET_LINEUP_RUBRIC = '@lineupBuilder/set_lineup_rubric',
  SET_SELECTED_MATCHUPS = '@lineupBuilder/set_selected_matchups',
  SET_CSV_HEADERS = '@lineupBuilder/set_csv_headers',
  SET_POOL_SIZE = '@lineupBuilder/set_pool_size',
  SET_PERCENT_TO_FIRST = '@lineupBuilder/set_percent_to_first',
  SET_LINEUP_CHECKED = '@lineupBuilder/set_lineup_checked',
  SET_SIM_RESULTS = '@lineupBuilder/set_sim_results',
  SET_PROJECTIONS = '@lineupBuilder/set_projections',
  SET_SLATE_PROJECTIONS = '@lineupBuilder/set_slate_projections',
  RESET_LINEUP = '@lineupBuilder/reset_lineups',
  SET_SAVED_LINEUPS = '@lineupBuilder/set_saved_lineups',
  DELETE_LINEUP = '@lineupBuilder/delete_lineup',
  DELETE_ALL_LINEUPS = '@lineupBuilder/delete_all_lineups',
  SET_LINEUP = '@lineupBuilder/set_lineup',
  TOGGLE_PLAYER_LOCK = '@lineupBuilder/toggle_player_lock',
  SET_LINEUP_RANDOMNESS = '@lineupBuilder/set_lineup_randomness',
  SET_DEFAULT_RANDOMNESS = '@lineupBuilder/set_default_randomness',
}